import { render, staticRenderFns } from "./EditStaffMember.vue?vue&type=template&id=19a70d7e&"
import script from "./EditStaffMember.vue?vue&type=script&lang=js&"
export * from "./EditStaffMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports